<elder-single-pane-wrapper>
  <elder-table class="flex" [data]="data" matSort (itemClick)="openDetail($event)">
    <elder-data-toolbar
      *elderTableToolbar
      (requestNew)="onRequestNew()"
      [canRemove]="canRemove()"
      [canAdd]="canAdd()"
      [canMore]="false"
    >
      <ng-template elderToolbarContent="center">
        <elder-search-box
          class="flex p-xs"
          dense
          queryKey="query"
          [autoPanel]="true"
          [elderSearchContext]="data.filter"
        >
          <!-- Advanced search -->
          <elder-search-panel class="layout-col p-sm">
            <div class="layout-row place-start-start gap-md">
              <mat-form-field floatLabel="always">
                <mat-label>{{ 'context.number' | translate }}</mat-label>
                <input matInput name="number" placeholder="-" elderSearchInput ngModel />
              </mat-form-field>

              <mat-form-field floatLabel="always">
                <mat-label>{{ 'packages.confirmationState.title' | translate }}</mat-label>
                <elder-select
                  appPackageStateSelect
                  name="confirmationStates"
                  elderSearchInput="confirmationState.value"
                  ngModel
                  [allowNull]="true"
                ></elder-select>
              </mat-form-field>

              <mat-form-field floatLabel="always">
                <mat-label>{{ 'storageGroups.storageGroup' | translate }}</mat-label>
                <input
                  matInput
                  name="storageGroupIds"
                  placeholder="-"
                  elderSearchInput
                  [ngModel]="storageGroupIdFilter"
                  [disabled]="!!storageGroupIdFilter"
                />
              </mat-form-field>

              <mat-form-field floatLabel="always">
                <mat-label>{{ 'context.orderReference' | translate }}</mat-label>
                <input
                  matInput
                  name="orderReferenceNumber"
                  placeholder="-"
                  elderSearchInput
                  ngModel
                  [disabled]="!!storageGroupIdFilter"
                />
              </mat-form-field>
            </div>
          </elder-search-panel>
        </elder-search-box>
      </ng-template>
    </elder-data-toolbar>

    <!-- icon -->
    <ng-container matColumnDef="icon">
      <th mat-header-cell *matHeaderCellDef style="width: 5%"></th>
      <td mat-cell *matCellDef="let row">
        <div class="layout-row place-start-center">
          <mat-icon>inventory_2</mat-icon>
        </div>
      </td>
    </ng-container>

    <!-- number Column -->
    <ng-container matColumnDef="number">
      <th mat-header-cell *matHeaderCellDef style="width: 10%" mat-sort-header>
        {{ 'context.number' | translate }}
      </th>
      <td mat-cell *matCellDef="let pkg">{{ pkg.number }}</td>
    </ng-container>

    <!-- state Column -->
    <ng-container matColumnDef="confirmationState">
      <th mat-header-cell *matHeaderCellDef style="width: 10%" mat-sort-header>
        {{ 'packages.confirmationState.title' | translate }}
      </th>
      <td mat-cell *matCellDef="let pkg">
        {{ 'packages.confirmationState.' + pkg.confirmationState | translate }}
      </td>
    </ng-container>

    <!-- storageGroupId Column -->
    <ng-container matColumnDef="storageGroupId">
      <th mat-header-cell *matHeaderCellDef style="width: 10%" mat-sort-header>
        {{ 'storageGroups.storageGroup' | translate }}
      </th>
      <td mat-cell *matCellDef="let pkg">{{ pkg.storageGroupId }}</td>
    </ng-container>

    <!-- packageGroupId Column -->
    <ng-container matColumnDef="packageGroupDetails.id">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'packageGroups.storageGroup' | translate }}
      </th>
      <td mat-cell *matCellDef="let pkg">
        <div class="layout-col">
          <span>{{ pkg.packageGroupDetails?.description }}</span>
          <span class="text-body-small">{{ pkg.packageGroupDetails?.id }}</span>
        </div>
      </td>
    </ng-container>

    <!-- location Column -->
    <ng-container matColumnDef="location">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="location.storagePath">
        {{ 'storage.location' | translate }}
      </th>
      <td mat-cell *matCellDef="let pkg">{{ pkg.location?.storagePath }}</td>
    </ng-container>

    <!-- contentWeight Column -->
    <ng-container matColumnDef="contentWeight">
      <th mat-header-cell *matHeaderCellDef style="width: 10%" mat-sort-header elderNumberCell>
        {{ 'context.contentWeight' | translate }}
      </th>
      <td mat-cell *matCellDef="let pkg" elderNumberCell>
        {{ pkg.contentWeight | elderQuantity }}
      </td>
    </ng-container>

    <!-- createdAt -->
    <ng-container matColumnDef="createdAt">
      <th mat-header-cell *matHeaderCellDef style="width: 10%" mat-sort-header>
        {{ 'context.createdAt' | translate }}
      </th>
      <td mat-cell *matCellDef="let pkg">
        {{ pkg.createdAt | date: 'short' }}
      </td>
    </ng-container>
  </elder-table>
</elder-single-pane-wrapper>
